import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'react-css-modules'
import _ from 'lodash'

import CpuConfigItem from './CpuConfigItem'

import styles from './styles.scss'

class CpuConfig extends Component {

  render() {
    const {
      values,
    } = this.props
    const cpuConfigItem =
      <CpuConfigItem
        curPart={values}
      />

    return <div>
      <h4 styleName='configTitle'></h4>
      { cpuConfigItem }
    </div>
  }
}

CpuConfig.propTypes = {
  values: PropTypes.array.isRequired,
}

export default CSSModules(CpuConfig, styles)
